<template>
    <div class="bar" :class="{ searchFocussed, [`size-${$mq}`]: true, noSelection: !selectCount }">
        <div class="selectAll" :class="{ searchFocussed, [`size-${$mq}`]: true }">
            <icon-button :icon="[ 'far', doSelectAll ? 'square' : 'check-square' ]" size="lg"
                    @click="$emit('selectAll', doSelectAll)" iconClass="mq-sm-nomargin"
                    :title="$t(doSelectAll ? 'messageListBar.selectAll' : 'messageListBar.unselectAll')"/>
        </div>
        <controlbar-wrapper class="buttons" :class="{ searchFocussed, [`size-${$mq}`]: true }">
            <icon-button icon="trash-alt" size="2x" v-if="rights.indexOf('t') !== -1"
                         @click="doDelete" :disabled="!selectCount" tabindex="-1"
                         :title="$t('messageListBar.delete')"/>

            <icon-button :icon="doMarkRead ? 'envelope-open-text' : 'envelope'" size="2x" tabindex="-1"
                         class="mq-mdplus"
                         @click="markRead(doMarkRead)" :disabled="!selectCount" v-if="rights.indexOf('s') !== -1"
                         :title="$t(doMarkRead ? 'messageListBar.markRead' : 'messageListBar.markUnread')"/>

            <icon-button :icon="[doMarkFlag ? 'fas' : 'fal', 'star']" size="2x" tabindex="-1" class="mq-mdplus"
                         @click="markFlag(doMarkFlag)" :disabled="!selectCount"  v-if="rights.indexOf('w') !== -1"
                         :title="$t(doMarkFlag ? 'messageListBar.markStarred' : 'messageListBar.markUnstarred')"/>

            <icon-button icon="paper-plane" size="2x" v-if="rights.indexOf('o') !== -1" tabindex="-1"
                    @click="$emit('cancelSend', uidArray)" :title="$t('messageBar.cancelsend')">
                <font-awesome-layers class="fa-2x">
                    <font-awesome-icon icon="paper-plane"></font-awesome-icon>
                    <font-awesome-icon icon="slash"></font-awesome-icon>
                </font-awesome-layers>
            </icon-button>
            <icon-button icon="redo" size="2x" v-if="rights.indexOf('o') !== -1" tabindex="-1"
                    @click="$emit('resend', uidArray)" :title="$t('messageBar.resend')">
                <font-awesome-layers class="fa-2x">
                    <font-awesome-icon icon="paper-plane" transform="shrink-7"></font-awesome-icon>
                    <font-awesome-icon icon="redo"></font-awesome-icon>
                </font-awesome-layers>
            </icon-button>

            <span style="position:relative">
                <icon-button icon="folders" size="2x" ref="showMoveSelectorButton" tabindex="-1"
                        @click="showMoveSelector" :disabled="!selectCount"
                        :title="$t('messageListBar.moveFolder')"/>
                <move-selector v-if="moveSelectorShowed"
                        v-click-outside="{ exclude: ['showMoveSelectorButton'], handler: 'hideMoveSelector'}"
                        @select="moveSelectorSelected" :rights="rights"
                        @hide="hideMoveSelector"/>
            </span>

            <drop-menu-button icon="bars" size="2x" tabindex="-1"
                    :aria="$t('messageListBar.moreMenu')" :options="moreMenu" menuname="messageListBar.menu"
                    @menu="doMenu"></drop-menu-button>

            <icon-button icon="redo" size="2x" v-show="showRefresh" tabindex="-1"
                    @click="doRefresh"
                    :title="$t('messageListBar.refresh')"/>
        </controlbar-wrapper>
        <select-count :class="{ selectCount: true, searchFocussed, [`size-${$mq}`]: true }"
            :selected="selectCount"
                :text="$mqIs('sm')?'messageListBar.selectedShort':'messageListBar.selected'"></select-count>
        <div class="searchboxwrap" :class="{ searchFocussed, [`size-${$mq}`]: true }">
            <search-box @focus="searchFocussed=$event" @search="$emit('search', $event)"></search-box>
        </div>
        <message-pager :pageLength="pageLength" class="pager"
                :start="start" :filteredLength="filteredLength"
                :actualLength="actualLength"
                :totalLength="totalLength"
                :selectedUIDs="selectedUIDs"
                @page="$emit('page', $event)"></message-pager>
    </div>
</template>

<script>
import MoveSelector from '@/components/moveSelector';
import IconButton from '@/components/iconButton';
import { EventBus } from '../event-bus';
import SearchBox from '@/components/searchBox';
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ControlbarWrapper from '@/components/controlbarWrapper';
import DropMenuButton from '@/components/DropMenuButton';
import SelectCount from '@/components/selectCount';
import MessagePager from '@/components/messagePager';

export default {
  name: 'messageListControlBar',
  components: { DropMenuButton,
    MoveSelector,
    IconButton,
    SearchBox,
    FontAwesomeIcon,
    FontAwesomeLayers,
    SelectCount,
    ControlbarWrapper,
    MessagePager },
  data: function() {
    return {
      moveSelectorShowed: false,
      moreMenuShowed: false,
      searchFocussed: false
    };
  },
  props: {
    messages: Array,
    selectedUIDs: Object,
    showRefresh: Boolean,
    folderid: String,
    outqueueShowSent: Boolean,
    rights: String,
    start: Number,
    filteredLength: Number,
    actualLength: Number,
    totalLength: Number,
    pageLength: Number
  },
  methods: {
    doMenu(evt) {
      if (evt === 'markRead') {
        this.markRead(this.doMarkRead);
      } else if (evt === 'markFlag') {
        this.markFlag(this.doMarkFlag);
      } else {
        this.$emit('menu', evt);
      }
    },
    doRefresh() {
      EventBus.$emit('messageListRefresh', { folderId: this.folderId });
    },
    doDelete(val) {
      if (this.selectCount > 0) {
        this.$emit('deleteMessages', this.uidArray);
      }
    },
    markRead(val) {
      if (this.selectCount > 0) {
        this.$emit('updateMessages', { uids: this.uidArray, newVal: { read: val } });
      }
    },
    markFlag(val) {
      if (this.selectCount > 0) {
        this.$emit('updateMessages', { uids: this.uidArray, newVal: { flagged: val } });
      }
    },
    showMoveSelector() {
      if (this.selectCount > 0) {
        this.moveSelectorShowed = !this.moveSelectorShowed;
      } else {
        this.moveSelectorShowed = false;
      }
    },
    hideMoveSelector() {
      this.moveSelectorShowed = false;
    },
    moveSelectorSelected({ targetFolder, copy }) {
      this.hideMoveSelector();
      this.$emit('moveMessages', {
        uids: this.uidArray,
        targetFolder,
        copy });
    },
    showMoreMenu() {
      this.moreMenuShowed = !this.moreMenuShowed;
    },
    hideMoreMenu() {
      this.moreMenuShowed = false;
    }
  },
  computed: {
    doSelectAll() {
      return this.selectCount < this.msgCount;
    },
    doMarkRead() {
      return this.markedReadCount < this.selectCount;
    },
    doMarkFlag() {
      return this.starredCount < this.selectCount;
    },
    moreMenu() {
      let menu = [
      ];

      if (this.rights.indexOf('s') !== -1) {
        if (this.$mqIs('sm')) {
          menu.push({
            text: this.$t(this.doMarkRead ? 'messageListBar.markReadMenu' : 'messageListBar.markUnreadMenu'),
            value: 'markRead' });
          menu.push({
            text: this.$t(this.doMarkFlag ? 'messageListBar.markStarredMenu' : 'messageListBar.markUnstarredMenu'),
            value: 'markFlag' });
        }
        menu.push({ text: this.$t('messageListBar.menu.markAllRead'), value: 'markAllRead' });
      }
      if (this.rights.indexOf('o') !== -1) {
        menu.push({ text: this.$t('messageListBar.menu.showSent'),
          value: 'outqueueShowSent',
          type: 'switch',
          checked: this.outqueueShowSent
        });
      }
      if (this.rights.indexOf('q') !== -1) {
        menu.push({ text: this.$t('messageListBar.menu.deleteAll'),
          value: 'deleteAll'
        });
        menu.push({ text: this.$t('messageListBar.menu.undeleteAll'),
          value: 'undeleteAll'
        });
      }
      return menu;
    },
    selectCount() {
      return Object.keys(this.selectedUIDs).length;
    },
    msgCount() {
      return this.messages.length;
    },
    markedReadCount() {
      return this.messages.reduce((a, m) => {
        return a + ((this.selectedUIDs[m.uid] && m.read) ? 1 : 0);
      }, 0);
    },
    starredCount() {
      return this.messages.reduce((a, m) => {
        return a + ((this.selectedUIDs[m.uid] && m.flagged) ? 1 : 0);
      }, 0);
    },
    uidArray() {
      return Object.keys(this.selectedUIDs).map(u => parseInt(u, 10));
    },
    folderId() {
      return parseInt(this.folderid, 10);
    }
  }
};
</script>

<style lang="scss">

</style>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';
    $bar-border : $control-bar-border;

    .bar {
        display: grid;
        grid-template-columns: 50px minmax(10em, 1fr) 1fr 140px auto;
        grid-template-areas: "selectall buttons count search pager";
        transition: grid-template-columns 0.5s, height 0.5s;
        height: 50px;
        &.searchFocussed {
            grid-template-columns: 50px 0 0 1fr;
        }

        &.size-sm {
            grid-template-columns: 30px 3ch 1fr 140px;
            grid-template-rows: 50px 50px;
            grid-template-areas: "pager pager pager search" "selectall count buttons buttons";
            height: 100px;
            overflow-y: hidden;

            &.noSelection {
                height: 50px;
            }

            &.searchFocussed {
                grid-template-columns: 0 30px 3ch 1fr;
                grid-template-areas: "pager search search search" "pager selectall count buttons";
            }

        }

        // padding: 10px 0 10px 0;
        // border-top: 1px solid $bar-border;
        border-bottom: 1px solid $bar-border;
        font-size: $message-list-size;
        position: relative;
        svg {
            margin-right:10px;
        }

        & > div {
            padding: 10px 0;
        }
        .selectAll {
            grid-area: selectall;
            &:not(.size-sm) {
                margin-left: 10px;
            }
            &.size-sm {
                border-top: 1px solid $bar-border;
            }
        }

        .buttons {
            grid-area: buttons;
            margin: 0 20px;
            white-space: nowrap;
            border-left: 1px solid $bar-border;
            padding-right: 20px;
            transition: opacity 0.5s;
            &:not(.size-sm) {
                &.searchFocussed {
                    opacity: 0;
                }
            }
            &.size-sm {
                border-top: 1px solid $bar-border;
                margin: 0;
            }
        }
        .selectCount {
            grid-area: count;
            font-size: 1rem;
            white-space: nowrap;
            transition: opacity 0.5s;
            overflow: hidden;
            &:not(.size-sm) {
                &.searchFocussed {
                    opacity: 0;
                }
            }
            &.size-sm {
                border-top: 1px solid $bar-border;
            }
        }

        .searchboxwrap {
            grid-area: search;
            font-size: 1rem;
            white-space: nowrap;
            border-right: 1px solid $bar-border;
            padding: 0;
            &.size-sm {
                border-right: none;
            }
        }

        .pager {
            padding-left: 5px;
            grid-area: pager;
            overflow: hidden;
        }
    }

</style>
